export default function isArray(a) {
  return Array.isArray(a)
}